var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"my-6 font-medium text-xs uppercase cursor-pointer",class:_vm.isActive ? 'text-xl font-bold' : '',on:{"click":_vm.linkClickHandler}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }